const setDefaultOutboundNumber = function (state, phoneNumber: string) {
  state.defaultOutboundNumber = phoneNumber
}

export default setDefaultOutboundNumber
